import { createAction, props } from '@ngrx/store';

export const loginAction = createAction('[User] Login User', props<{}>());

export const loginSucessAction = createAction('[User] Login Success User', props<{}>());

export const loginErrorAction = createAction('[User] Login Error User', props<{ error: any }>());

export const logoutAction = createAction('[User] Logout User', props<{}>());

export const logoutSucessAction = createAction('[User] Logout Success User', props<{}>());

export const logoutErrorAction = createAction('[User] Logout Error User', props<{ error: any }>());

